import * as React from 'react';

import * as ReactDOM from 'react-dom';

import { useAppData } from '@modules/_shared/providers/AppDataProvider';
import { useDocumentTitle } from '@shared/components/documentTitle';

type TopbarState = {
  titleRef: { current: HTMLDivElement | null };
};

const TopbarContext = React.createContext<TopbarState | null>(null);

export const TopbarProvider = ({ children }: { children: React.ReactNode }) => {
  const titleRef = React.useRef<HTMLDivElement | null>(null);

  const value = React.useMemo(
    () => ({
      titleRef,
    }),
    [],
  );

  return (
    <TopbarContext.Provider value={value}>{children}</TopbarContext.Provider>
  );
};

export const useTopbar = (): TopbarState => {
  const context = React.useContext(TopbarContext);
  if (context == null) {
    throw Error('<TopbarProvider> should be in the tree');
  }
  return context;
};

export const TopbarTitle = ({
  children,
  titleOverride,
}: {
  children: React.ReactNode;
  titleOverride?: null | string;
}) => {
  const { me } = useAppData();
  const tenantName = me?.tenant.name;
  const { titleRef } = useTopbar();
  let textForTitleElement = children;

  if (titleOverride != null) {
    textForTitleElement = titleOverride;
  }

  useDocumentTitle(
    <>
      {textForTitleElement} | {tenantName + ' CRM'}
    </>,
  );

  if (titleRef.current == null) {
    return null;
  }

  return ReactDOM.createPortal(children, titleRef.current);
};
